import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import VueScrollTo from 'vue-scrollto'
import MachineWatausa2 from "../component/pages/machineIntroduction/MachineWatausa2.vue"

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')
const isSearchableStr = document.getElementById('isSearchable').textContent
const isSearchable = isSearchableStr.toLowerCase() === "true"

const vue = createApp(
    MachineWatausa2,
    {
        unsavedPuriCount: unsavedPuriCount,
        latestImageId: latestImageId,
        isSearchable: isSearchable,
    }
)
    .use(Store)
    .use(VueScrollTo)
    .mount('#machineWatausa2')

export default vue
